export default {
  labels: [],
  issuerLabels: [],
};
